import { useState } from 'react';
import { Button, PermissionGuard } from '@/shared';
import {
  ResidentFiltersComponent,
  ResidentsErrorBoundary,
  ResidentTable,
  type ResidentFiltersType,
} from '../components';
import { Pagination } from '@/features/houses';
import { AddResidentModal } from '../components/modals';
import { useResidentsQuery } from '../hooks/useResidentQueries';

const ManageResidentsPageContent = () => {
  const [filters, setFilters] = useState<ResidentFiltersType>({
    page: 1,
    limit: 10,
    search: '',
    status: 'ACTIVE',
    paymentStatus: '',
    moveInDate: '',
    location: '',
  });
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const { data } = useResidentsQuery(filters);
  console.log('resident', data);
  const residents = data?.residents;
  const pagination = data?.pagination;

  return (
    <div className="min-h-screen bg-background w-full">
      {/* Header  */}
      <div className="w-full flex flex-col lg:flex-row items-center justify-between gap-4 mb-8 px-0 sm:px-6 lg:px-8">
        <div className="text-center lg:text-start w-full lg:w-[80%]">
          <h3 className="text-lg md:text-3xl font-bold mb-2 text-text-primary">
            Manage residents
          </h3>
          <p className="text-gray-600 text-base md:text-xl text-text-secondary">
            Manage your properties with ease
          </p>
        </div>
        <PermissionGuard permission="manageResidents">
          <Button
            variant="primary"
            size="lg"
            leftIcon={
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 1V7M7 7V13M7 7H13M7 7L1 7"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            onClick={() => setIsModalOpen(true)}
          >
            Add residents
          </Button>
        </PermissionGuard>
      </div>

      <div className="px-0 sm:px-6 lg:px-8">
        {/* Filters */}
        <div className="mb-6">
          <ResidentFiltersComponent
            filters={filters}
            setFilters={setFilters}
            totalResidents={pagination?.totalRecords}
          />
        </div>

        {/* Houses Grid */}
        {residents?.length === 0 ? (
          <div className="text-center py-12">
            <div className="text-text-secondary mb-4">
              <svg
                className="w-16 h-16 mx-auto mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
                />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-text-primary mb-2">
              No Residents found
            </h3>
            <p className="text-text-secondary">
              {filters.search
                ? 'Try adjusting your search terms'
                : 'Get started by adding your first house'}
            </p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <ResidentTable data={residents || []} isLoading={false} className='min-h-[50vh]' />
          </div>
        )}

        {/* Pagination */}
        <div className="w-full flex items-center justify-end mt-6">
          {/* <Pagination /> */}
          <Pagination
            totalPages={pagination?.totalPages || 1}
            currentPage={pagination?.currentPage || 1}
            hasPrevPage={pagination?.hasNextPage || false}
            hasNextPage={pagination?.hasNextPage || false}
            onPageChange={(page) => setFilters((prev) => ({ ...prev, page }))}
          />
        </div>
      </div>

      {isModalOpen && (
        <AddResidentModal isOpen={true} onClose={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};

export const ManageResidentsPage = () => {
  return (
    <ResidentsErrorBoundary onRetry={() => window.location.reload()}>
      <ManageResidentsPageContent />
    </ResidentsErrorBoundary>
  );
};
